/* eslint-disable */
import axios from "axios";
import store from "@/store";
import moment from "moment";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import ViewCtqRegistryModal from "./viewCtqRegistry.vue";
import approveRejectModal from "../GenericApproveRejectModal/GenericApproveRejectModal.vue";
import CtqAddEditModal from "./CtqAddEditModal.vue";
import MitigationInfoModal from "./Mitigationinfomodal.vue";
import RiskListModal from "./RiskListModal.vue";
import QtlInfoModal from "./QtlInfoModal.vue";

export default {
    name: "ctqRegistry",

    components: {
        VPagination,
        ViewCtqRegistryModal,
        approveRejectModal,
        CtqAddEditModal,
        MitigationInfoModal,
        RiskListModal,
        QtlInfoModal,
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            loading: false,
            reportList: [],
            currentPage: 1,
            pageSize: 12,
            totalCount: 0,
            totalPages: 0,
            SortProperty: "createdAt",
            SortOrder: 0,
            expandedRows: new Set(),

            // View modal
            selectedCtq: null,
            showViewModal: false,

            // Mitigation modal
            selectedCtqForMitigation: null,
            showMitigationModal: false,

            // Risk list modal
            selectedCtqForRiskList: null,
            showRiskListModal: false,

            // QTL modal
            selectedCtqForQTL: null,
            showQTLModal: false,

            // Approve / Reject
            showApproveRejectPopup: false,
            selectedCtqPayload: {},
            approveApiEndpoint: "",

            // Bulk selection
            selectedItems: new Set(),

            // Add / Edit modal
            showCtqModal: false,
            selectedCtqData: null,

            // Filters — CTQID and CTQFactor match the API query param names exactly
            searchField: {
                ctqId: "",
                category: "",
                priority: "",
            },

            defaultdate: "",
            rollsprivilages: ""
        };
    },

    computed: {
        isAllSelected() {
            const selectable = this.reportList.filter(
                (item) => !this.isFinalized(item.approvals?.[0]?.status)
            );
            if (selectable.length === 0) return false;
            return selectable.every((item) => this.selectedItems.has(item.id));
        },
    },

    async mounted() {
        this._studyIdChangedHandler = async () => {
            this.rollsprivilages = store.getters.getRolesprivilegeData;
            this.studyId = store.getters.getStudyIs;
            this.token = store.getters.getIdToken;
            this.currentPage = 1;
            await this.getStudyDetails(this.studyId);
            await this.getReportList();

        };
        window.addEventListener("studyIdChanged", this._studyIdChangedHandler);
        this.rollsprivilages = store.getters.getRolesprivilegeData;
        this.defaultdate = localStorage.getItem("dateformat");
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.getStudyDetails(this.studyId);
        this.getReportList();
    },

    beforeUnmount() {
        window.removeEventListener("studyIdChanged", this._studyIdChangedHandler);
    },

    methods: {
        async getStudyDetails(studyId) {
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/study/getstudylock`,
                    {
                        params: { studyId: studyId, },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.studyDetails = response.data;
            } catch (error) {
                console.error("Error fetching study details:", error);
                return null;
            }
        },
        isFinalized(status) {
            return status === "Approved" || status === "Rejected";
        },

        // ── List ───────────────────────────────────────────────────────────

        async getReportList() {
            this.loading = true;
            this.clearSelections();

            try {
                const response = await axios.get(
                    this.baseurl + "/forms/ctq/getstudyctqlist",
                    {
                        params: {
                            StudyId: this.studyId,
                            CTQID: this.searchField.ctqId || undefined,
                            Category: this.searchField.category || undefined,
                            Priority: this.searchField.priority || undefined,
                            IsActive: true,
                            pageindex: this.currentPage,
                            pagesize: this.pageSize,
                            SortProperty: this.SortProperty,
                            SortOrder: this.SortOrder,
                        },
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );

                var apiData = response.data || {};
                this.reportList = apiData.entities || [];
                this.totalCount = apiData.totalCount || 0;
                this.totalPages = Math.ceil(this.totalCount / this.pageSize);

            } catch (error) {
                console.error("Error fetching CTQ registry list:", error);
                this.reportList = [];
            } finally {
                this.loading = false;
            }
        },

        filter(data) {
            if (data) {
                return moment(data).format(this.defaultdate);
            }
        },

        searchReports() {
            this.currentPage = 1;
            this.getReportList();
        },

        sortSelected(property) {
            if (this.SortProperty === property) {
                this.SortOrder = this.SortOrder === 0 ? 1 : 0;
            } else {
                this.SortProperty = property;
                this.SortOrder = 0;
            }
            this.currentPage = 1;
            this.getReportList();
        },

        // ── Selection helpers ──────────────────────────────────────────────

        clearSelections() {
            this.selectedItems = new Set();
        },

        toggleSelection(id) {
            var item = this.reportList.find(function (r) { return r.id === id; });
            if (item && this.isFinalized(item.approvals && item.approvals[0] && item.approvals[0].status)) return;

            var updated = new Set(this.selectedItems);
            if (updated.has(id)) {
                updated.delete(id);
            } else {
                updated.add(id);
            }
            this.selectedItems = updated;
        },

        toggleSelectAll(event) {
            if (event.target.checked) {
                var selectableIds = this.reportList
                    .filter((item) => !this.isFinalized(item.approvals && item.approvals[0] && item.approvals[0].status))
                    .map((item) => item.id);
                this.selectedItems = new Set(selectableIds);
            } else {
                this.selectedItems = new Set();
            }
        },

        // ── Single approve / reject ────────────────────────────────────────

        openApproveRejectPopup(item) {
            var loggedInUser = jwt_decode(store.getters.getIdToken);
            this.approveApiEndpoint = this.baseurl + "/management/study/approvemultiplectq";
            this.selectedCtqPayload = {
                studyId: this.studyId,
                ctQIds: [item.id],
                approvedByEmail: loggedInUser.email,
            };
            this.showApproveRejectPopup = true;
        },

        onApproveRejectSuccess() {
            this.showApproveRejectPopup = false;
            this.getReportList();
        },

        // ── Bulk approve ───────────────────────────────────────────────────

        async bulkApprove() {
            if (this.selectedItems.size === 0) return;

            var loggedInUser = jwt_decode(store.getters.getIdToken);
            var payload = {
                studyId: this.studyId,
                ctQIds: Array.from(this.selectedItems),
                approvedByEmail: loggedInUser.email,
                status: "Approved",
                comments: "",
            };

            try {
                await axios.put(
                    this.baseurl + "/management/study/approvemultiplectq",
                    payload,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                await this.getReportList();
            } catch (error) {
                console.error("Bulk approve failed:", error);
            }
        },
        // ── Bulk reject ────────────────────────────────────────────────────

        async bulkReject() {
            if (this.selectedItems.size === 0) return;

            var loggedInUser = jwt_decode(store.getters.getIdToken);
            var payload = {
                studyId: this.studyId,
                ctQIds: Array.from(this.selectedItems),
                approvedByEmail: loggedInUser.email,
                status: "Rejected",
                comments: "",
            };

            try {
                await axios.put(
                    this.baseurl + "/management/study/approvemultiplectq",
                    payload,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                await this.getReportList();
            } catch (error) {
                console.error("Bulk reject failed:", error);
            }
        },

        // ── Bulk remove ────────────────────────────────────────────────────

        async bulkRemove() {
            if (this.selectedItems.size === 0) return;

            var payload = { ctQIds: Array.from(this.selectedItems) };

            try {
                await axios.put(
                    this.baseurl + "/management/study/removectq",
                    payload,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                await this.getReportList();
            } catch (error) {
                console.error("Bulk remove failed:", error);
            }
        },

        // ── Upload ─────────────────────────────────────────────────────────

        async uploadCtqFile(event) {
            try {
                var file = event.target.files[0];
                if (!file) return;
                this.loading = true;

                var formData = new FormData();
                formData.append("file", file);

                await axios.post(
                    this.baseurl + "/forms/ctq/uploadstudyctq",
                    formData,
                    {
                        params: {
                            studyId: this.studyId,
                            studyRef: this.studyDetails?.studyRef,
                        },
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                alert("CTQ file uploaded successfully");
                this.currentPage = 1;
                await this.getReportList();

            } catch (error) {
                console.error("Error uploading CTQ file:", error);
                alert((error && error.response && error.response.data && error.response.data.message) || "Failed to upload CTQ file");
            } finally {
                this.loading = false;
            }
        },

        // ── View modal ─────────────────────────────────────────────────────

        viewDetails(item) {
            this.selectedCtq = this.normalizeCtqItem(item);
            this.showViewModal = true;
        },

        closeViewModal() {
            this.showViewModal = false;
            this.selectedCtq = null;
        },

        // ── Mitigation modal ───────────────────────────────────────────────

        viewMitigation(item) {
            this.selectedCtqForMitigation = item;
            this.showMitigationModal = true;
        },

        closeMitigationModal() {
            this.showMitigationModal = false;
            this.selectedCtqForMitigation = null;
        },

        // ── CTQ Add/Edit modal ─────────────────────────────────────────────

        openCreateThreshold() {
            this.selectedCtqData = null;
            this.showCtqModal = true;
        },

        openEditCtq(item) {
            var normalized = this.normalizeCtqItem(item);
            normalized.studyCTQId = item.id;
            this.selectedCtqData = normalized;
            this.showCtqModal = true;
        },

        closeCtqModal() {
            this.showCtqModal = false;
            this.selectedCtqData = null;
        },

        async onSaveCtq() {
            this.closeCtqModal();
            this.currentPage = 1;
            await this.getReportList();
        },

        // ── Normalizer ─────────────────────────────────────────────────────

        normalizeCtqItem(item) {
            var reviewPlanDefault = { reviewFrequency: "", reviewOwner: "", reviewMethod: "" };
            return Object.assign({}, item, {
                risks: Array.isArray(item.risks) ? item.risks : [],
                linkedKRIs: Array.isArray(item.linkedKRIs) ? item.linkedKRIs : [],
                criticalDataPoints: Array.isArray(item.criticalDataPoints) ? item.criticalDataPoints : [],
                criticalProcesses: Array.isArray(item.criticalProcesses) ? item.criticalProcesses : [],
                qtLs: Array.isArray(item.qtLs) ? item.qtLs : [],
                approvals: Array.isArray(item.approvals) ? item.approvals : [],
                reviewPlan: (item.reviewPlan !== null && item.reviewPlan !== undefined) ? item.reviewPlan : reviewPlanDefault,
            });
        },

        // ── Risk list modal ───────────────────────────────────────────────

        viewRisks(item) {
            this.selectedCtqForRiskList = item;
            this.showRiskListModal = true;
        },

        closeRiskListModal() {
            this.showRiskListModal = false;
            this.selectedCtqForRiskList = null;
        },

        viewQTL(item) {
            console.log("viewQTL clicked", item);
            this.selectedCtqForQTL = item;
            this.showQTLModal = true;
            console.log(this.showQTLModal);
        },
        closeQTLModal() {
            this.showQTLModal = false;
            this.selectedCtqForQTL = null;
        },

        toggleExpand(id) {
            const updated = new Set(this.expandedRows);
            if (updated.has(id)) {
                updated.delete(id);
            } else {
                updated.add(id);
            }
            this.expandedRows = updated;
        },
    },
};